import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Automatic recovery from stale chunks following deployments
window.addEventListener('vite:preloadError', () => {
  const now = Date.now();
  const last = Number(sessionStorage.getItem('scalebulk_chunk_reload') || 0);
  if (now - last > 5000) {
    sessionStorage.setItem('scalebulk_chunk_reload', String(now));
    window.location.reload();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
